import React from 'react';

class Item extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: props.selected || false
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (nextProps.selected !== this.props.selected);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			selected: nextProps.selected || false
		});
	}

	onChange = (e) => {
		const selected = e.target.checked;

		this.setState({ selected }, function () {
			this.props.onChange(this.props.id, selected);
		});
	}

	render() {
		let className = "item level-" + this.props.level;

		return (
			<div className={className}>
				<label>
					<input
						id={this.props.id}
						type="checkbox"
						className="checkbox pull-left"
						onChange={this.onChange}
						checked={this.state.selected}
						disabled={this.props.disabled} />
					<span>{this.props.text}</span>
				</label>
			</div>
		)
	}
}

export default Item;



// WEBPACK FOOTER //
// ./src/areas/admin/roleSetup/roleInfo/Item.js